
const BASE_URL = "https://wa.me/557798460632"; 
const DEFAULT_MESSAGE = "Olá! Gostaria de saber mais sobre os serviços da Overx.";

/**
 * Gera um link do WhatsApp com texto personalizado dependendo
 * @param {string} message Texto que será enviado no WhatsApp
 * @returns {string} URL completa do WhatsApp
 */
export function getWhatsAppLink(message = DEFAULT_MESSAGE) {
  const encodedMessage = encodeURIComponent(message);
  return `${BASE_URL}?text=${encodedMessage}`;
}
